var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup48095509(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48095509",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1149",
    cx: 26.5,
    cy: 26.5,
    r: 25.5,
    fill: "#FFE6E6",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "3d fire"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.426 18.0286L32.9416 16.9571C32.9416 16.9571 32.1747 18.5064 32.1447 19.9754C32.1239 20.9881 31.8462 22.0694 31.4368 21.9662C31.3483 21.839 31.2603 21.7124 31.1755 21.59C31.161 21.4945 31.1581 21.3799 31.1692 21.2446C31.2895 19.7856 31.8208 18.6254 31.6704 15.5724C31.5917 13.9745 30.9453 12.7439 30.2638 11.8771L30.2548 11.5193L28.5184 10.2706C28.283 10.0903 28.1317 10 28.1317 10C28.1317 10 28.3157 12.3494 26.8723 15.9821C25.4289 19.6149 24.9155 19.3814 24.26 22.0486C24.2291 22.1746 24.2016 22.2943 24.1758 22.4109L22.9731 21.5427C22.9731 21.5427 21.9978 23.6674 21.074 25.5057C18.7354 30.1592 18.4297 35.7182 20.8681 37.7794C20.9367 37.8374 22.9814 39.3136 22.9814 39.3136L34.426 18.0286Z",
    fill: "url(#paint0_linear_715_334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.9797 21.7477L31.8953 26.4231C31.8953 26.4231 34.7444 21.083 34.6963 20.971L34.8739 18.3499L32.9416 16.9572C32.9416 16.9572 32.1748 18.5065 32.1447 19.9755C32.1317 20.6065 32.293 21.4606 31.9797 21.7477Z",
    fill: "url(#paint1_linear_715_334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.5165 25.4937L23.9089 29.1029L27.4817 28.93C27.4817 28.93 30.7493 14.6659 30.7493 13.7582C30.7493 13.1887 30.0629 11.3881 30.0614 11.3802L28.5183 10.2706C28.2829 10.0903 28.1315 10 28.1315 10C28.1315 10 28.3156 12.3494 26.8722 15.9821C25.4288 19.6149 24.9153 19.3814 24.2599 22.0486C24.229 22.1746 24.2015 22.2943 24.1756 22.4109L23.4209 21.8638L24.9053 22.9354L24.5165 25.4937Z",
    fill: "url(#paint2_linear_715_334)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.8003 39.1722C24.9121 40.9574 29.2651 39.8062 32.6591 36.1957C36.2977 32.3251 37.2425 27.374 36.6714 23.8069C36.301 21.4935 35.3851 20.9272 35.1294 20.1376C34.8738 19.3481 34.8738 18.3498 34.8738 18.3498C34.8738 18.3498 34.107 19.8992 34.077 21.3682C34.0469 22.8373 32.5333 23.7754 32.6536 22.3163C32.7739 20.8573 33.3052 19.6971 33.1548 16.6441C32.9817 13.1308 30.0638 11.3928 30.0638 11.3928C30.0638 11.3928 30.2479 13.7421 28.8045 17.375C27.3611 21.0078 26.8476 20.7743 26.1922 23.4414C25.5367 26.1085 26.0881 26.6107 25.6069 27.7218C25.1258 28.833 24.1435 28.0266 24.7048 26.1333C25.2662 24.2401 24.9053 22.9355 24.9053 22.9355C24.9053 22.9355 23.93 25.0602 23.0061 26.8985C20.6675 31.5521 20.3618 37.111 22.8003 39.1722Z",
    fill: "url(#paint3_linear_715_334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.6034 27.3894C30.6143 26.318 30.7475 23.8094 30.7475 23.8094C30.7475 23.8094 29.4606 25.1944 28.8105 27.3632C28.1605 29.5321 28.5409 31.0215 27.9703 31.3873C27.3996 31.7531 27.0953 30.9693 27.2475 30.1069C27.3996 29.2446 27.2085 27.8074 27.2085 27.8074C27.2085 27.8074 27.0763 28.9572 26.3725 30.2376C25.6687 31.518 25.1644 33.2071 25.2503 34.915C25.471 39.3052 30.0152 35.892 30.0152 35.892C31.3371 34.9252 32.9834 33.5078 33.2963 31.0999C33.6387 28.4652 32.5925 28.4607 31.6034 27.3894Z",
    fill: "url(#paint4_linear_715_334)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_334",
    x1: 19.9398,
    y1: 34.5924,
    x2: 27.2179,
    y2: 21.7179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5587,
    stopColor: "#FF4757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_715_334",
    x1: 32.3162,
    y1: 21.8824,
    x2: 35.7451,
    y2: 15.4352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8205,
    stopColor: "#FF4757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_334",
    x1: 24.8112,
    y1: 25.0971,
    x2: 31.3715,
    y2: 12.7621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5587,
    stopColor: "#FF4757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_334",
    x1: 30.2927,
    y1: 38.9131,
    x2: 26.894,
    y2: 16.0805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_334",
    x1: 29.9808,
    y1: 36.0503,
    x2: 28.2702,
    y2: 27.0252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37A34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E041"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48095509);
export default __webpack_public_path__ + "static/media/Group 48095509.ad230f0372abb890a8771c189050cbbf.svg";
export { ForwardRef as ReactComponent };